import React, { useEffect } from 'react';
import styled from 'styled-components';
interface IFutureFashion {
  productId: string;
}

const Container = styled.div`
  padding: 64px 24px;
  ${props => props.theme.breakpoints.up('sm')} {
    padding: 64px 32px;
  }
`;
const IframeContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;
  margin: 0 auto;
  ${props => props.theme.breakpoints.up('sm')} {
    width: 480px;
    height: 480px;
  }
  ${props => props.theme.breakpoints.up('tablet')} {
    width: 600px;
    height: 600px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    width: 700px;
    height: 700px;
    padding-top: 0%;
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: 0;
    margin: 0 auto;
  }
`;

const FutureFashion: React.FC<IFutureFashion> = ({ productId }) => {
  useEffect(() => {
    window.Mirta.pushEventToAnalytics('3dviewer-view');
  }, []);
  return (
    <Container>
      <IframeContainer>
        <iframe
          src={`https://3dviewer.futurefashionsolution.com/?customerId=${process.env.NEXT_PUBLIC_CUSTOMER_ID_FUTURE_FASHION}&productId=${productId}`}></iframe>
      </IframeContainer>
    </Container>
  );
};

export default FutureFashion;
